import { ReactElement } from "react";

import {
  ThreadDisplayPane,
  ThreadListCollapse,
  ThreadListContainer,
  ThreadListPane,
  ThreadSplitView,
} from "~frontend/components/threads";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";
import { useIntl } from "~frontend/providers/IntlProvider";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";
import { TexterSettingsProvider } from "~frontend/providers/TexterSettingsProvider";

import { ThreadsProvider } from "../../../components/threads/ThreadsProvider";
import ThreadDetails from "./ThreadDetails";
import ThreadList from "./ThreadList";
import ThreadListControls from "./ThreadListControls";

export function ThreadsList(): ReactElement {
  const { subaccountLink } = useSubaccount()!;
  const intl = useIntl();
  useBreadcrumbs([
    {
      label: intl.formatMessage({
        defaultMessage: "Threads",
        description: 'Title of the "Threads" page',
      }),
      path: subaccountLink("/threads"),
    },
  ]);

  return (
    <ThreadsProvider>
      <TexterSettingsProvider>
        <ThreadListContainer>
          <ThreadListControls />
          <ThreadSplitView>
            <ThreadListCollapse>
              <ThreadListPane>
                <ThreadList />
              </ThreadListPane>
            </ThreadListCollapse>
            <ThreadDisplayPane>
              <ThreadDetails />
            </ThreadDisplayPane>
          </ThreadSplitView>
        </ThreadListContainer>
      </TexterSettingsProvider>
    </ThreadsProvider>
  );
}
